import { useAuthStore } from '../stores/authStore';
import { useTierStore } from '../stores/tierStore';
import { isFeatureEnabled, type FeatureFlag } from '../lib/featureFlags';

/**
 * Hook to check if a feature flag is enabled for the current user.
 * Considers both alpha email and user tier.
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  const email = useAuthStore((s) => s.user?.email);
  const tier = useTierStore((s) => s.tier);
  return isFeatureEnabled(flag, email, tier);
}
